import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';

import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';
import {refresh as paginatorRefresh} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';


export default class Markers extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
    }

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {field: item => `${item.firstname} ${item.lastname}`, label: window.gettext('Name')},
        {
            field: item => item.materials.length > 0
                ? _.map(item.materials, material => material.title).join(window.gettext(','))
                : '-',
            label: window.gettext('Grade'),
        },
        {field: 'national_id', label: window.gettext('National ID')},
    ]

    filtersSelector = createSelector.bind(this)(
        [() => this.props.store.getIn(['materialsTreeFilter'])],
        () => [
            {
                field: 'material',
                label: window.gettext('Material'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('materialsTreeFilter')}
                        readonly
                        header
                        resource='material'
                        itemLabel='title'
                        label={window.gettext('Material')}
                    />
                </div>,
                selected: this.props.store.getIn(['materialsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'material',
                    this.props.store.getIn(['materialsTreeFilter', 'elementId']),
                )),
            },
        ],
    )

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'national_id', label: window.gettext('national id')},
        {name: 'firstname', label: window.gettext('firstname')},
        {name: 'lastname', label: window.gettext('lastname')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size,
        ],
        () => this.props.readonly
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                        {
                            label: window.gettext('Mass Edit'),
                            action: () => this.context.store.dispatch(push(
                                this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                ) + this.props.store.getIn(['paginator', 'selected']).keySeq().join(',') + '/',
                            )),
                        },
                    ]
                    : [],
            ),
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
        ],
        () => this.props.readonly
            ? this.props.buttonActions
            : _.concat(this.props.buttonActions, [
                {
                    label: window.gettext('New Marker'),
                    action: () => this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + 'add/',
                    )),
                },
            ]),
    );

    componentDidUpdate(prevProps) {
        if (prevProps.params && prevProps.params.id && (!this.props.params || !this.props.params.id)) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='marker'
            title={window.gettext('Markers')}
            listFields={this.listFields}
            readonly={this.props.readonly}
            selectable
            filters={this.filtersSelector(this.props.store)}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            active={this.props.params ? this.props.params.id : undefined}
            actions={this.actionsSelector(this.props.store)}
            buttonActions={this.buttonActionsSelector(this.props.store)}
        />;
    }
}
